import React, {useState, useContext, useEffect} from 'react';
import { IonText, IonGrid, IonRow, IonCol, IonButton, IonModal, IonContent, IonList, IonItem, IonInfiniteScroll, IonInfiniteScrollContent, IonHeader, IonFooter } from '@ionic/react';
import ReactDOM from 'react-dom';


import { Auth_MerchantID_context } from '../../../storeState/auth_merchantID_context';
import { HistoryOrderDetailsModal } from './Modal_HistoryOrderDetails';

//import classes from './Modal_ViewModal.module.css';
import '../../../css/qavaApp.css';

const Backdrop = props => {
    return <div className='backdrop'/>
};

export function ViewOrderHistroyListModal (props) {

    let authClient_context = useContext(Auth_MerchantID_context);


    const [acctID, setAcctID ] = useState(authClient_context.acctID);
    let [sessionID, setSessionID ] = useState(authClient_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authClient_context.baseURL);

    let [startDate, setStartDate] = useState(props.startDate);
    let [endDate, setEndDate] = useState(props.endDate);

    let [viewEstimates, setViewEstimates] = useState([]);

    let [estimateID, setEstimateID] = useState(null);
    let [totalAmount, setTotalAmount] = useState(null);

    let [showEstimateDetailsModal, setShowEstimateDetailsModal] = useState(false);

    useEffect(() => {



        if(props.openModal == true && startDate != null && endDate != null)
        {

            const requestOptions = {
                method: 'POST',
                //credentials: 'include',
                headers: {
                    'Accept': 'text/html, application/json',
                    'content-type': 'application/json',
                    //'cookie': 'cookie',
                },
                body: JSON.stringify({
                    Tracker: '74101_orderHistory_list',
                    user: acctID,
                    xStartDateRange: props.startDate.toISOString().substr(0, 10),
                    xEndDateRange: props.endDate.toISOString().substr(0, 10),
                    sessionID: sessionID,
    
                }),
            }

            
            fetch(baseURL+'proService_merchantAcct_argsjqApp', requestOptions)
            .then(res => res.text())
            .then(res => {

                let rows = res.toString().split('~~~');

                for (let rownum = 0; rownum < rows.length - 1; ++rownum)
                {
                    let cols = rows[rownum].split('|');

                    setViewEstimates((prevAvailableRooms) => {
                        return prevAvailableRooms.concat({
                            estimateID: cols[0],
                            customerFirstName: cols[1],
                            customerLastName: cols[2],
                            customerMobileNumber: cols[3],
                            estimateDescription: new Date(cols[4]).toISOString().substr(0, 10),
                            estimateLatitude: parseFloat(cols[5]).toFixed(2),
                            estimateLongitude: cols[6],
                            dateLogged: cols[7],
                            estimateImage1: cols[8],
                            status: cols[9],
                        })
                    });
                } 
            })
        }
    }, [props.openModal]);

    function deleteEstimate(enteredPassword)
    {

        /*
        let formData = new FormData();
        formData.append('Tracker', '74002D');
        formData.append('user', acctID);
        formData.append('xEstimateID', estimateID);
        formData.append('xEnterAdminPassword', enteredPassword);

        const requestOptions = {
            enctype: 'multipart/form-data',
            method:'POST',
            credentials: 'include',
            files: formData,
            body: formData,
            contentType: false,
            processData: false,
        }
        */

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '74002D',
                user: acctID,
                xEstimateID: estimateID,
                xEnterAdminPassword: enteredPassword,
                sessionID: sessionID,

            }),
        }

        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            alert(data);

            props.closeModal(false);

        })
        .catch(error => {
            console.error(error);
        })
    }

    function closeModalHandler(event) {

        setViewEstimates([]);
        props.closeModal(event);
    }
 
    function viewEstimateDetailsHandler(event) {


        setEstimateID(event[1]);
        setShowEstimateDetailsModal(event[0]);

        //setRoomID(event[1]);
        //setRoomSalePrice(event[2]);
    }

    function viewDeleteEstimateHandler(event) {


        //setShowPasswordModal(event[0]);
        setEstimateID(event);
    }

    function onSubmitPasswordHandler(event)
    {
        deleteEstimate(event);
    }



    return (

        <React.Fragment> 
           
            {props.openModal == true ?
            (
                <div>
                {ReactDOM.createPortal(<Backdrop />, document.getElementById('backdrop-root'))}

                <IonModal isOpen={ props.openModal }>
                    <IonHeader className='appModalHeader'>
                        <h3> One-Time Estimates </h3>
                    </IonHeader>

                    <IonContent >
                        <IonGrid className='appGridContent'>
                            <IonRow >
                                    <IonCol size='4'> <h3> Customer Name </h3> </IonCol>
                                    {/*<IonCol className='appGridCol' size='2'> <h3> Supplier Phone </h3> </IonCol>*/}
                                    {/*<IonCol className='appGridCol' size='3'> <h3> Estimate Description </h3> </IonCol>*/}
                                    <IonCol size='4'> <h3> Date Logged </h3> </IonCol>
                                    <IonCol size='4'> <h3> Action </h3> </IonCol>
                            </IonRow>
                        {viewEstimates.map((detailData) =>   {
                            return (
                                    <IonRow key={detailData.estimateID}>
                                        <IonCol size='3'>{detailData.supplierName}</IonCol>
                                        {/*<IonCol className='appGridCol' size='2'>{detailData.supplierPhoneNumber}</IonCol>*/}
                                        {/*<IonCol className='appGridCol' size='3'>{detailData.expenseDescription}</IonCol>*/}
                                        <IonCol size='3'>{detailData.dateLogged}</IonCol>
                                        <IonCol size='3'>

                                            <IonButton className='appListButton' onClick={() => viewEstimateDetailsHandler([true, detailData.estimateID])}> Details </IonButton>
                                            {authClient_context.accessRights[0] == 'admin' && <IonButton className='appListButton' onClick={() => viewDeleteEstimateHandler(detailData.estimateID)}> Delete </IonButton>}
                                            {/*<IonButton class='gridResultColumnButton' onClick={() => setViewAttachemntModal(true)}> View Invoice</IonButton>*/}
                                    
                                        </IonCol>
                                    </IonRow>
                            )
                        }
                        )}
                        </IonGrid>


                        <HistoryOrderDetailsModal openModal={ showEstimateDetailsModal } closeModal={() => setShowEstimateDetailsModal(false)} data={{
                                            estimateID: estimateID, 
                                            }}></HistoryOrderDetailsModal>

                    </IonContent>

                    <IonFooter className='modal_footer_button_center'>
                        <IonButton onClick={() => closeModalHandler(false)}> Close </IonButton>
                    </IonFooter>

                </IonModal>            
            </div>
            ) : null }

        </React.Fragment>

    )
}